import { useState } from 'react';

const useCustomHook = () => {
  const [checkingContact, setCheckingContact] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [foundUser, setFoundUser] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [enteredCaptcha, setEnteredCaptcha] = useState(''); // محتویات وارد شده در تکس باکس کپچا دیالوگ فایل تکراری
  const [captchaId, setCaptchaId] = useState(null); // محتویات کپچا آیدی دیالوگ فایل تکراری 

  return {
    checkingContact, setCheckingContact,
    submitting, setSubmitting,
    foundUser, setFoundUser,
    isConfirmModalOpen, setIsConfirmModalOpen,
    enteredCaptcha, setEnteredCaptcha,
    captchaId, setCaptchaId
  };
};

export default useCustomHook;
